import React, {useEffect} from "react";
import {connect} from "react-redux";
import {Source, Layer} from "react-map-gl";
import {getGeojsonPoint6} from "../../../actions/map";
import {encodedPolylineType} from "../../../@opentripplanner/core-utils/src/types";
import PropTypes, {object} from "prop-types";
import polyline from "@mapbox/polyline";


function RouteViewerOverlay(props) {
  const {path, routeData, map} = props;

  const routeColor = routeData ? (routeData.color ? `#${routeData.color}`
    : (routeData.route && routeData.route.color ? `#${routeData.route.color}`
      : path.color ?? null)) : null;

  const isGeomComplete = routeData => {
    return (
      routeData &&
      routeData.patterns &&
      Object.values(routeData.patterns).every(
        ptn => typeof ptn.geometry !== "undefined"
      )
    );
  };

  const applyToArray = (func, array) => func.apply(Math, array);

  useEffect(() => {
    if(isGeomComplete(routeData)) {
      const allPoints = Object.values(routeData.patterns).reduce(
        (acc, ptn) => {
          return acc.concat(polyline.decode(ptn.geometry.points6,6));
        },
        []
      );

      const pointsLat = allPoints.map(point => point[0]);
      const pointsLong = allPoints.map(point => point[1]);

      const cornersLongLat = [
        [applyToArray(Math.min, pointsLong), applyToArray(Math.min, pointsLat)],
        [applyToArray(Math.max, pointsLong), applyToArray(Math.max, pointsLat)]
      ];

      map?.fitBounds(cornersLongLat, {
        padding: 25
      });
    }
  }, [routeData]);

  return (
    <>
      {(routeData && routeData.patterns) && Object.values(routeData.patterns).map(
        (pattern, index) => (
          <div key={index}>
            <div key={pattern.id}>
              {pattern.geometry && <div>
                <Source id={"line_" + index} type="geojson" data={getGeojsonPoint6(pattern.geometry.points6)}/>
                <Layer type="line" source={"line_" + index} id={'routeLayer_' + pattern.id}
                       paint={{'line-color': routeColor, 'line-width': 5}} layout={{'line-join': "round"}}
                />
              </div>}
            </div>
          </div>
        )
      )}
    </>
  )

}

RouteViewerOverlay.propTypes = {
  path: object,
  routeData: PropTypes.shape({
    color: PropTypes.string,
    patterns: PropTypes.objectOf(
      PropTypes.shape({
        geometry: encodedPolylineType,
        id: PropTypes.string.isRequired
      }).isRequired
    )
  })
};

RouteViewerOverlay.defaultProps = {
  path: {
    color: "#00bfff",
    opacity: 1,
    weight: 4
  }
};

const mapStateToProps = (state, ownProps) => {
  const viewedRoute = state.otp.ui.viewedRoute
  return {
    routeData: viewedRoute && state.otp.transitIndex?.routes ? state.otp.transitIndex.routes[viewedRoute.routeId] : null,
    ...state
  }
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(RouteViewerOverlay);